import React, {useState} from 'react';
import './hero.scss';
//IMAGES
import IMAGE_1 from 'assets/home-page/hero_image_1.png'
import IMAGE_2 from 'assets/home-page/hero_image_2.png'
import IMAGE_3 from 'assets/home-page/hero_image_3.png'

import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination, Navigation} from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {Button} from "components";
import {ReactComponent as FACE_BOOK_IMAGE} from "../../../../assets/icons/facebook_icon.svg";
import {ReactComponent as INSTAGRAM_IMAGE} from "../../../../assets/icons/instagram_icon.svg";
import {ReactComponent as YOUTUBE_IMAGE} from "../../../../assets/icons/youtube_icon.svg";
import {ReactComponent as TWITTER_IMAGE} from "../../../../assets/icons/twitter_icon.svg";
import {ReactComponent as ARROW_ICON} from "../../../../assets/icons/arrow_icon.svg";
import {useNavigate} from "react-router-dom";

export const Hero: React.FC = () => {
    const [swiper, setSwiperRef] = useState<any>(null);
    const navigate = useNavigate()

    const [heroOptions] = useState<{ link: string, heading: string, description: string, image: any }[]>([
        {
            heading: "Jamaica Business Industries",
            description: "Learn more about the different business industries in jamaica.",
            link: "#",
            image: IMAGE_1
        },
        {
            heading: "Business Financial Advice",
            description: "Get the support you need to manage your business financial need",
            link: "#",
            image: IMAGE_2
        },
        {
            heading: "Experts Guidance",
            description: "Meet with industry experts and learn how you can improve the quality of your products or services",
            link: "#",
            image: IMAGE_3
        },
    ])
    return (
        <div className={'hero'}>
            <div className="hero_wrapper">
                <div className="hero_wrapper_left">
                    <div className="hero_wrapper_left_content">
                        <div className="hero_wrapper_left_content_socials">
                            <div className={'hero_wrapper_left_content_socials_wrapper'}>
                                <FACE_BOOK_IMAGE/>
                            </div>
                            <div className={'hero_wrapper_left_content_socials_wrapper'}>
                                <INSTAGRAM_IMAGE/>
                            </div>
                            <div className={'hero_wrapper_left_content_socials_wrapper'}>
                                <YOUTUBE_IMAGE/>
                            </div>
                            <div className={'hero_wrapper_left_content_socials_wrapper'}>
                                <TWITTER_IMAGE/>
                            </div>
                        </div>
                        <div className="hero_wrapper_left_content_text">
                            <h1>Small Business Association of Jamaica</h1>
                            <p>Over 45 years of experience working with small businesses in Jamaica to help them plan, start and
                                grow their businesses.</p>
                            <div className={'hero_wrapper_left_content_text_buttons'}>
                                <Button text={'Join Us'} type={'primary'} onclick={() => navigate('/registration/#')}/>
                                <Button text={'Learn More'} type={'secondary'} onclick={() => navigate('/about')}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero_wrapper_right">
                    <div className="hero_wrapper_right_content">
                        <Swiper
                            onSwiper={setSwiperRef}
                            slidesPerView={"auto"}
                            centeredSlides={false}
                            spaceBetween={30}
                            pagination={{
                                type: "fraction",
                            }}
                            navigation={false}
                            modules={[Pagination, Navigation]}
                            className="mySwiper"
                        >
                            {
                                heroOptions.map(({link, heading, description, image}, index) => (
                                    <SwiperSlide key={heading + index}>
                                        <HeroCard
                                            link={link}
                                            image={image}
                                            heading={heading}
                                            description={description}
                                        />
                                    </SwiperSlide>

                                ))
                            }
                        </Swiper>
                    </div>
                    <div className={'slide-navigation'}>
                        <div className={'slide-navigation_option'} onClick={() => swiper?.slidePrev()}>
                            <ARROW_ICON/>
                            <span>Prev</span></div>
                        <div className={'slide-navigation_option'} onClick={() => swiper?.slideNext()}>
                            <span>Next</span>
                            <ARROW_ICON/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


interface HeroCardProps {
    image: any;
    heading: string,
    description: string,
    link: string
}

const HeroCard: React.FC<HeroCardProps> = ({image, heading, description, link}) => {
    const navigate = useNavigate()
    return (
        <div className="hero-card">
            <div className="hero-card_content">
                <h2>{heading}</h2>
                <p className="hero-card_content_cta">{description}</p>
                <span onClick={() => navigate(link)}>Learn more</span>
            </div>
            <div className="hero-card_img">
                <img src={image} alt=""/>
            </div>
        </div>
    );
};

export default HeroCard;
